import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateLastResolvedNotificationMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type UpdateLastResolvedNotificationMutation = { updateLastResolvedNotificationTimestamp: { success?: boolean | null } };


export const UpdateLastResolvedNotificationDocument = /*#__PURE__*/ gql`
    mutation updateLastResolvedNotification {
  updateLastResolvedNotificationTimestamp {
    success
  }
}
    `;

export function useUpdateLastResolvedNotificationMutation() {
  return Urql.useMutation<UpdateLastResolvedNotificationMutation, UpdateLastResolvedNotificationMutationVariables>(UpdateLastResolvedNotificationDocument);
};